import React from 'react';
import { Card } from 'antd';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import getProfileTypeLogoUrl from 'utils/getProfileTypeLogoUrl';
import './styles.less';

const ProfileTypeCard = ({ profileType, onClick, selected, disabled }) => {
  const handleClick = () => {
    if (!disabled) {
      onClick(profileType.profileTypeId);
    }
  };

  const handleEnter = (event) => {
    if (!disabled) {
      if (event.key === 'Enter') {
        onClick(profileType.profileTypeId);
      }
    }
  };

  const cardClass = clsx('profile-type-card', {
    'profile-type-card--selected': selected,
    'profile-type-card--disabled': disabled,
  });
  return (
    <Card
      id={profileType.profileTypeId}
      onClick={handleClick}
      onKeyUp={handleEnter}
      hoverable={!selected && !disabled}
      className={cardClass}
      bodyStyle={{ height: '100%' }}
      tabIndex={0}
    >
      <div className="profile-type-card__body">
        <img
          className="profile-type-card__body__img"
          src={getProfileTypeLogoUrl(profileType.profileTypeId)}
          alt={profileType.profileTypeId}
          title={profileType.profileTypeId}
        />
      </div>
    </Card>
  );
};

ProfileTypeCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  profileType: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
};

ProfileTypeCard.defaultProps = {
  selected: false,
  disabled: false,
};

export default ProfileTypeCard;
